<template>
    <main>
        <div v-if="can.view" class="flex flex-col w-full xl:w-5/6 max-w-1440 mx-auto">
            <application-list></application-list>
        </div>
        <error-403 v-else></error-403>
    </main>
</template>

<script>
import Error403 from '../components/ui/Error403.vue';
import ApplicationList from '../components/applications/ApplicationList.vue';
import {mapStores} from "pinia";
import {useMainStore} from "../state/store";
import {useApplicationsStore} from "../state/modules/applications";

export default {
    beforeRouteLeave(to, from, next) {
        this.applicationsModuleStore.resetState();
        next();
    },
    components: {
        'error-403': Error403,
        'application-list': ApplicationList,
    },
    computed: {
        ...mapStores(useMainStore, useApplicationsStore),
        can() {
            return {
                view: this.$can(['applications.view', 'applications.view.*', 'job-applications.view.*']),
            };
        },
    },
    mounted () {
        this.applicationsModuleStore.resetState();
        this.mainStore.setDocumentTitle(this.$t('applications.title'));
    }
};
</script>
